export default "__VITE_ASSET__B9kkG84v__"